import { Injectable } from "@angular/core";
import { Action, NgxsOnInit, Selector, State, StateContext } from "@ngxs/store";
import { patch } from "@ngxs/store/operators";
import { tap, catchError, finalize } from "rxjs/operators";
import { Payment } from "src/app/interface/payment";
import { ApiService } from "../services/api.service";
import {
  GetCartPay,
  PayCartNative,
  PayCoins,
  UploadPaymentProof,
} from "./actions/payment.actions";
import { v1 as uuid } from "uuid";
import { AlertService } from "../services/alert.service";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { environment } from "src/environments/environment";
import { of } from "rxjs";
import { trace } from "console";

@State<Payment>({
  name: "payment",
  defaults: {},
})
@Injectable()
export class PaymentState implements NgxsOnInit {
  ngxsOnInit({ dispatch }: StateContext<Payment>) {
    dispatch(new PayCoins());
  }
  constructor(
    private api: ApiService,
    private alertService: AlertService,
    private storage: AngularFireStorage
  ) {}

  @Selector()
  static getPaymentProof(state: Payment): {
    paymentProofURL: string;
    paymentProofId: string;
  } {
    return {
      paymentProofURL: state.paymentProofURL,
      paymentProofId: state.paymenteProoId,
    };
  }

  @Selector()
  static billToPay({ billToPay }: Payment) {
    return billToPay;
  }

  @Selector()
  static coins({ coins }: Payment) {
    return coins;
  }

  @Action(UploadPaymentProof)
  uploadPaymentProof(
    { patchState }: StateContext<Payment>,
    { file }: UploadPaymentProof
  ) {
    const uuidImage = uuid();
    const firebaseId = `payments/${environment.bucket_place}${uuidImage}`;
    const fileRef = this.storage.ref(firebaseId);
    const uploadTask = this.storage.upload(firebaseId, file);

    return uploadTask.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe({
          next: (url) => {
            patchState({ paymenteProoId: firebaseId, paymentProofURL: url });
          },
          error: (error) => {
            this.alertService.openSnackBar(
              "Error al obtener el comprobante",
              "error"
            );
          },
        });
      }),
      catchError(() => {
        this.alertService.openSnackBar(
          "Error al obtener el comprobante",
          "error"
        );
        return of(null);
      })
    );
  }

  @Action(GetCartPay)
  getCartPay({ setState }: StateContext<Payment>, id: GetCartPay) {
    return this.api.billToPay(id).pipe(
      tap(({ data: { billToPay } }) => {
        setState(patch({ billToPay }));
      })
    );
  }

  @Action(PayCartNative)
  payCartNative({}: StateContext<Payment>, { cart }: PayCartNative) {
    return this.api.payCartNative(cart).pipe(
      tap(({ data }) => {
        if (
          window["webkit"] &&
          window["webkit"].messageHandlers["cordova_iab"]
        ) {
          window["webkit"].messageHandlers["cordova_iab"].postMessage(
            JSON.stringify({ complete: true, data })
          );
        } else {
          window.close();
        }
      })
    );
  }

  @Action(PayCoins)
  payCoins({ setState }: StateContext<Payment>) {
    return this.api.allCoins().pipe(
      tap(({ data: { coins } }) => {
        if (coins) {
          setState(patch({ coins }));
        }
      })
    );
  }
}
